<template>
  <div class="product-highlights">
    <div class="product-highlights__header">
      <h2
        v-if="liquid.title"
        id="section-title-{{ liquid.sectionId }}"
        class="
          product-highlights__title
          text-heading-3xl
          text-heading-4xl-desktop
        "
        v-text="liquid.title"
      />

      <p
        class="product-highlights__subcopy text-body-m-regular"
        v-text="liquid.subcopy"
      />
    </div>
    <div class="product-highlights__mobile-nav">
      <button
        v-for="(block, index) of liquid.blocks"
        :key="index"
        class="product-highlights__highlight text-heading-s"
        :style="{
          'left': block.xPosition,
          'top': block.yPosition,
        }"
        type="button"
        @click.prevent="handleZoomClick(block)"
      >
        <span
          class="product-highlights__highlight-label"
          v-text="block.title"
        />
      </button>
    </div>

    <div class="product-highlights__media">
      <responsive-image
        class="product-highlights__image"
        :image="liquid.image"
        ratio="3:2"
        min-max="360-1440"
      />

      <button
        v-for="(block, index) of liquid.blocks"
        :key="index"
        class="product-highlights__highlight text-heading-s"
        :style="{
          'left': block.xPosition,
          'top': block.yPosition,
        }"
        type="button"
        @click.prevent="handleZoomClick(block)"
      >
        <span class="product-highlights__highlight-icon">
          <plus v-if="currentFeature.title !== block.title" />
          <minus v-if="currentFeature.title === block.title" />
        </span>

        <span
          class="product-highlights__highlight-label"
          v-text="block.title"
        />
      </button>
    </div>

    <overlay
      key="productHighlightDrawer"
      block-class="product-highlights-drawer"
      direction="left"
      namespace="productHighlightDrawer"
      show-overlay
      show-close
      type="drawer"
    >
      <template #body>
        <responsive-image
          v-if="currentFeature.imageType === 'image' && currentFeature"
          class="product-highlights-drawer__image"
          :image="currentFeature.image"
          ratio="4:3"
        />

        <responsive-video
          v-if="currentFeature.imageType === 'video' && currentFeature"
          class="product-highlights-drawer__video"
          :video-src="currentFeature.video"
          ratio="4:3"
          :lazyload="false"
          autoplay-enabled="true"
          ratio-desktop="4:3"
        />

        <div class="product-highlights-drawer__content">
          <h3
            v-if="currentFeature"
            class="text-heading-2xl"
            :class="currentFeature.title ? 'mt-l' : ''"
            v-text="currentFeature.title"
          />
          <div
            v-if="currentFeature"
            class="
              text-body-regular-m mt-s
              "
            v-html="currentFeature.subcopy"
          />
        </div>
      </template>
    </overlay>
  </div>
</template>

<script>

/**
 * Vue: Product highlights (product-highlights)
 * -----------------------------------------------------------------------------
 * Interactive section to highlight product features.
 * - Limited interactivity section.
 *
 * @param {String} liquid.sectionId - Section's Liquid ID.
 *
 */
import ResponsiveImage from '~global/images/responsive-image'
import ResponsiveVideo from '~global/videos/responsive-video'
import Overlay from '~global/overlay/overlay'
import Plus from '~icons/general/plus.svg'
import Minus from '~icons/general/minus.svg'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'ProductHighlights',
  components: {
    ResponsiveImage,
    ResponsiveVideo,
    Overlay,
    Plus,
    Minus,
  },
  props: {
    liquid: {
      type: Object,
      default: () => ({
        sectionId: '',
        image: {},
      }),
    },
  },

  data() {
    return {
      currentFeature: {},
    }
  },
  computed: {

    /**
     * Map Vuex getters.
     */
    ...mapGetters({
      getFirstElement: 'accessibility/getFirstElement',
      getActiveOverlay: 'overlays/getActiveOverlay',
    }),

  },
  watch: {

    /**
     * Watch active overlay to reset current feature.
     */
    getActiveOverlay() {
      if (!this.getActiveOverlay) {
        this.currentFeature = {}
      }
    },

  },
  mounted() {
    // Not empty
  },

  methods: {

    /**
     * Map Vuex actions.
     */
    ...mapActions({
      openOverlay: 'overlays/open',
    }),

    /**
     * Handle zoom click.
     */
    handleZoomClick(feature) {
      this.currentFeature = feature

      this.openOverlay({
        ignoreDismissed: true,
        namespace: 'productHighlightDrawer',
      })
    },
  },
}
</script>

<style lang="scss">
@import './product-highlights';
</style>
